import React, { useEffect } from 'react';

import type { Page } from '../domain/page';
import { AppcuesService } from '../services/appcues';

export const useAppcuesPageChange = (page: Page) => {
  const previousPage = React.useRef<Page | null>(null);

  useEffect(() => {
    if (page === previousPage.current) {
      return;
    }

    previousPage.current = page;
    AppcuesService.pageChange(page);
  }, [page]);
};
